(function() {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('PromotorService', PromotorService);

  function PromotorService($http, ngsalConfig) {
    var service = {
      consultarPromotor: consultarPromotor
    };

    return service;

    function consultarPromotor(query, timeoutPromise, somenteAtivos = false) {

      var promise = $http.post(`/mgp-corregedoria/api/${ngsalConfig.apiVersion}/promotor`, {
        somenteAtivos: somenteAtivos,
        query: query
      }, {
        timeoutPromise
      })
      .then(function(response) {
        return response.data;
      });

      return promise;

    }
  }

})();
